.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--cxy-spacing-4) var(--cxy-spacing-4);
}

.logo img {
  display: block;
}

.cta {
  display: none;
}

@media (min-width: 1025px) {
  .header {
    justify-content: space-between;
  }

  .cta {
    display: inline-flex;
    align-items: center;
    background-color: var(--cxy-color-brand);
    color: var(--cxy-color-content-primary);
    font-size: var(--cxy-fontSize-m);
    font-weight: var(--cxy-fontWeight-bold);
    text-transform: uppercase;
    text-decoration: none;
    border-radius: var(--cxy-border-radius-s);
    padding: 12px 56px;
  }

  .cta:hover {
    opacity: 0.9;
  }
}
